import EcoBundle1 from 'eco-design/sections/eco-bundle-1';
import { EcoBundle1ItemProps } from 'eco-design/sections/eco-bundle-1/eco-bundle-1-item';
import ProductBundles from './components/product';
import styles from './index.module.scss';

export default function Comp({ addShopCartCallback }: any) {
    return (
        <div className={styles.comp}>
            <ProductBundles addShopCartCallback={addShopCartCallback} />
        </div>
    );
}
